import { render } from "./RightPanel.vue?vue&type=template&id=5e810f3e&scoped=true"
import script from "./RightPanel.vue?vue&type=script&lang=js"
export * from "./RightPanel.vue?vue&type=script&lang=js"

import "./RightPanel.vue?vue&type=style&index=0&id=5e810f3e&scoped=true&lang=css"

import exportComponent from "/Users/tomoiida/Dropbox/LegalNetwork/limar/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e810f3e"]])

export default __exports__